const questions = [
  {
    number: 1,
    correct: 98,
    given: null,
    question: 'How much of Scotland’s land area is classified as rural?',
    reaction: null,
    fact: "Only 2% of Scotland's land is in cities or towns larger than 3,000 people, although 83% of the population live there.",
    min: 0,
    max: 100,
    source: 'Scottish Government',
    sourceUrl: "https://www.gov.scot/binaries/content/documents/govscot/publications/statistics/2018/10/rural-scotland-key-facts-2018/documents/rural-scotland-key-facts-2018-pdf/rural-scotland-key-facts-2018-pdf/govscot%3Adocument/00541327.pdf"
  },
  {
    number: 2,
    correct: 29,
    given: null,
    question: 'What proportion of Scotland’s population lives within 500 metres of a vacant or derelict piece of land?',
    reaction: null,
    fact: 'The amount varies between places. At the extremes, Orkney and Shetland is less than 1% but in Inverclyde and Glasgow it is 60%.',
    min: 0,
    max: 100,
    source: 'Scottish Government',
    sourcUrl: "https://www.gov.scot/binaries/content/documents/govscot/publications/statistics/2019/04/scottish-vacant-derelict-land-survey-2018/documents/scottish-vacant-derelict-land-survey-2018/scottish-vacant-derelict-land-survey-2018/govscot%3Adocument/scottish-vacant-derelict-land-survey-2018.pdf"
  },
  {
    number: 3,
    correct: 29,
    given: null,
    question: 'To have net-zero greenhouse gas emissions by 2050, how much of Scotland would need to be woodland?',
    reaction: null,
    fact: 'In 2016, 20% of Scotland was woodland. The Committee for Climate Change are advising planting millions of new trees to offset carbon emissions.',
    min: 0,
    max: 100,
    source: 'The Committee on Climate Change',
    sourceUrl: "https://www.theccc.org.uk/publication/land-use-policies-for-a-net-zero-uk/"
  },
  {
    number: 4,
    correct: 52,
    given: null,
    question: 'What percentage of adults in Scotland visit a public greenspace at least once a week?',
    reaction: null,
    fact: 'A worldwide study found that people who grew up with good access to greenspace were 45% less likely to experience mental health problems in their lifetime.',
    min: 0,
    max: 100,
    source: 'Scottish Government & World Health Organisation',
    sourceUrl: [
      "https://statistics.gov.scot/slice?dataset=http%3A%2F%2Fstatistics.gov.scot%2Fdata%2Foutdoor-visits&http%3A%2F%2Fpurl.org%2Flinked-data%2Fsdmx%2F2009%2Fdimension%23refPeriod=http%3A%2F%2Freference.data.gov.uk%2Fid%2Fyear%2F2017",
      "http://www.euro.who.int/__data/assets/pdf_file/0005/321971/Urban-green-spaces-and-health-review-evidence.pdf?ua=1"
    ]
  },
  {
    number: 5,
    correct: 100,
    given: null,
    question: 'Since 2003, wages in Scotland increased by 47%. How much did house prices increase by?',
    reaction: null,
    fact: 'In April 2003 the average house price was £91,089, by the end of 2019 this had increased to £184,446.',
    min: 0,
    max: 100,
    source: 'Registers of Scotland & Scottish Government',
    sourceUrl: [
      "https://www.ros.gov.uk/data-and-statistics/house-price-statistics",
      "http://www.euro.who.int/__data/assets/pdf_file/0005/321971/Urban-green-spaces-and-health-review-evidence.pdf?ua=1",
      "https://statistics.gov.scot/slice?dataset=http%3A%2F%2Fstatistics.gov.scot%2Fdata%2Fearnings&http%3A%2F%2Fpurl.org%2Flinked-data%2Fcube%23measureType=http%3A%2F%2Fstatistics.gov.scot%2Fdef%2Fmeasure-properties%2Fmedian&http%3A%2F%2Fstatistics.gov.scot%2Fdef%2Fdimension%2Fgender=http%3A%2F%2Fstatistics.gov.scot%2Fdef%2Fconcept%2Fgender%2Fall&http%3A%2F%2Fstatistics.gov.scot%2Fdef%2Fdimension%2FpopulationGroup=http%3A%2F%2Fstatistics.gov.scot%2Fdef%2Fconcept%2Fpopulation-group%2Fresidence-based&http%3A%2F%2Fstatistics.gov.scot%2Fdef%2Fdimension%2FworkingPattern=http%3A%2F%2Fstatistics.gov.scot%2Fdef%2Fconcept%2Fworking-pattern%2Fall-patterns"
    ]
  },
  {
    number: 6,
    correct: 432,
    given: null,
    question: "Scotland has a population of 5,438,100. How many people own half of Scotland’s land?",
    reaction: null,
    fact: 'In 2012, around 430 owners were estimated to own  land equivalent to 50% of Scotland’s land area as a whole.',
    min: 0,
    max: 5500000,
    source: 'Scottish Land Commission & National Records of Scotland',
    sourceUrl: [
      "https://landcommission.gov.scot/downloads/5dd6c6f024659_Land-Lines-Land-Ownership-Peter-Peacock-March-2018.pdf",
      "https://www.nrscotland.gov.uk/files//statistics/nrs-visual/rgar-2018/rgar-2018-infographic-booklet.pdf"
    ]
  },
]

export default questions;
